import homeRouter from './home-router'

const routes = [
  {
    path: '/wishTree',
    name: 'WishTree',
    component: () => import('@/view/wishTree/wish-tree.vue'),
    meta: {
      title: '许愿树',
      auth: '查看许愿树',
    }
  },
  {
    path: '/',
    redirect: '/wishTree',
    exact: true
  },
  {
    redirect: '/404',
    path: '/:pathMatch(.*)',
  },
]

export default routes
